export default "__VITE_ASSET__B4f4DwwD__"